var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-step', {
    attrs: {
      "md": _vm.md,
      "isDone": _vm.isDone,
      "title": _vm.header.title,
      "description": _vm.header.description,
      "debug": [_vm.numberplate, _vm.user, _vm.contact, _vm.address]
    }
  }, [_c('v-card', {
    staticClass: "pt-4",
    attrs: {
      "flat": "",
      "max-width": "500"
    }
  }, [_c('form', [_c('v-text-field', {
    attrs: {
      "label": "Kennzeichen *",
      "value": _vm.numberplate,
      "rules": _vm.numberPlateRules,
      "hint": _vm.numberplateHint,
      "required": ""
    },
    on: {
      "blur": _vm.updateNumberplate
    }
  }), _c('v-text-field', {
    attrs: {
      "value": _vm.user.firstName,
      "label": "Vorname *",
      "rules": [function (v) {
        return !!v || 'Eingabe ist erforderlich';
      }],
      "required": ""
    },
    on: {
      "blur": _vm.updateUserFirstName
    }
  }), _c('v-text-field', {
    attrs: {
      "value": _vm.user.lastName,
      "label": "Nachname *",
      "rules": [function (v) {
        return !!v || 'Eingabe ist erforderlich';
      }],
      "required": ""
    },
    on: {
      "blur": _vm.updateUserLastName
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Telefon *",
      "value": _vm.contact.phone,
      "type": "tel",
      "rules": _vm.phoneNumberRules,
      "required": ""
    },
    on: {
      "blur": _vm.updateUserPhone
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Email *",
      "value": _vm.contact.email,
      "type": "email",
      "rules": _vm.emailRules,
      "autocomplete": "email",
      "required": ""
    },
    on: {
      "blur": _vm.updateUserEmail
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Straße und Hausnummer *",
      "value": _vm.address.street,
      "rules": [function (v) {
        return !!v || 'Eingabe ist erforderlich';
      }],
      "required": ""
    },
    on: {
      "blur": _vm.updateUserStreet
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Postleitzahl *",
      "type": "number",
      "value": _vm.address.zip,
      "rules": [function (v) {
        return !!v || 'Eingabe ist erforderlich';
      }],
      "required": ""
    },
    on: {
      "blur": _vm.updateUserZip
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Stadt *",
      "value": _vm.address.city,
      "rules": [function (v) {
        return !!v || 'Eingabe ist erforderlich';
      }],
      "required": ""
    },
    on: {
      "blur": _vm.updateUserCity
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }